import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginComponent } from './login/login.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
	declarations: [LoginComponent],
	imports: [
		CommonModule,
		SharedModule,
		AuthenticationRoutingModule,
		NgOptimizedImage
	]
})
export class AuthenticationModule {}
